import { DemandCasesQuery } from '@/generated/gql/graphql';

export enum DemandCasesDataGridField {
  CASE_NUMBER = 'sequenceNumber',
  SUPPLIER = 'supplier',
  VARIANT = 'variant',
  PROCESS_STATUS = 'processStatus',
  STATUS = 'status',
  TOTAL_VALUE = 'totalValue',
  TOTAL_SAVINGS_PERCENTAGE = 'discount',
  DELIVERY_TIME = 'deliveryTime',
  CONTACT_FIRST_NAME = 'contactFirstName',
  CONTACT_LAST_NAME = 'contactLastName',
  CONTACT_EMAIL = 'contactEmail',
  CONTACT_PHONE = 'contactPhone',
  UPPER_DISCOUNT_BOUNDARY = 'upperDiscountBoundary',
  LOWER_DISCOUNT_BOUNDARY = 'lowerDiscountBoundary',
  NEGOTIATION_MODE = 'negotiationMode',
  QUOTE_MODE = 'quoteMode',
  IS_RELEASEABLE = 'isReleasable',
  HAS_SUPPLIER_COMMENT = 'hasSupplierComment',
  ISSUES_OPEN_COUNT = 'issuesOpenCount',
  LATEST_COMMENT = 'latestComment',
}

export enum DemandCasesDataGridColumnGroup {
  CASE = 'case',
  CONTACT = 'contact',
  TERMS = 'terms',
  ISSUES = 'issues',
}

type DemandCasesNode = DemandCasesQuery['tesseract']['demand']['negotiationCases']['nodes'][number];

type LatestComment = {
  id: string;
  message: string;
  authorId: string;
  createdAt?: string;
};

export type DemandCasesDataGridRow = Omit<DemandCasesNode, 'latestComment'> & {
  latestComment?: LatestComment | null;
};
